import './Home.css';

import { getCounts, handleRequestError, ICounters, Logger, Page } from '@desp-aas/desp-ui-fwk';
import { useEffect, useState } from 'react';

import Navigation from '../../components/Navigation/Navigation';
import Hero from './Hero';
import SectionsMain from './sections/SectionsMain';

const logger = new Logger('HomePage', 'home');

export default function HomePage() {
    const [counts, setCounts] = useState<ICounters | undefined>();

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                setCounts(await getCounts());
            } catch (e) {
                logger.error('[fetchCounts] error fetching counts');
                handleRequestError(e);
            }
        };
        fetchCounts();
    }, []);

    return (
        <Page id="home-page">
            <Navigation />
            <Hero counts={counts} />
            <SectionsMain />
        </Page>
    );
}
